const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || "";

const baseURL = {
  apiBaseUrl,
};

/** Staging / local only — false for production builds. */
export const isNonProductionEnv = (() => {
  const url = apiBaseUrl.toLowerCase();
  return (
    process.env.NODE_ENV === "development" ||
    url.includes("staging") ||
    url.includes("localhost") ||
    url.includes("127.0.0.1")
  );
})();

export default baseURL;
